import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import { resetErrorMessage } from 'actions/common'
import { getMarket } from 'selectors/entities'
import { getCurrentPartner } from 'selectors/settings'
import ErrorMessage from './error-message'

export class ErrorMessageContainer extends Component {

  getLastEventId() {
    return typeof Raven !== 'undefined' && Raven.lastEventId() // eslint-disable-line no-undef
  }

  render() {
    const { error, market, isFixed, isSmall } = this.props
    if (!market) {
      return null
    }

    return (
      <ErrorMessage
        error={error}
        id={error && error.id || ''}
        isFixed={isFixed}
        isSmall={isSmall}
        lastEventId={this.getLastEventId()}
        market={market}
        resetErrorMessage={this.props.resetErrorMessage}
      />
    )
  }

}

ErrorMessageContainer.propTypes = {
  error: PropTypes.object,
  isFixed: PropTypes.bool,
  isSmall: PropTypes.bool,
  market: PropTypes.object,
  resetErrorMessage: PropTypes.func,
}

const mapStateToProps = (state, ownProps) => {
  const partner = getCurrentPartner(state)

  return {
    error: state.error,
    market: partner ? getMarket(partner.market)(state) : ownProps.market,
  }
}

const mapDispatchToProps = { resetErrorMessage }

const options = { pure: true }

export default connect(mapStateToProps, mapDispatchToProps, null, options)(ErrorMessageContainer)



/** WEBPACK FOOTER **
 ** ./src/components/error-message/error-message-container.js
 **/